import React, { Component, PropTypes } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import styles from './SearchResults.scss';
import * as actions from 'src/redux/searchActions';
import * as toCartActions from 'src/components/ToCartPopup/redux/toCartPopupActions'
import Media from 'react-responsive';
import SearchInfo from './elements/SearchInfo';
import SearchInfoMobile from './elements/SearchInfoMobile';
import SearchMap from './elements/SearchMap';
import SearchPageHeader from './elements/SearchPageHeader';
import ToCartPopup from 'src/components/ToCartPopup/ToCartPopup';
import { browserHistory } from 'react-router';
import cx from 'classnames';

export class SearchResults extends Component {
  constructor(props, context) {
    super(props, context);
    browserHistory.listen((location) => {
      const detailNum = location.query.detailNum;
      this.props.onSearchInputChange(detailNum);
      this.props.submitSearch(detailNum);
    });
  }

  componentWillUnmount() {
    this.props.onSearchInputChange('');
  }

  render() {
    const isCartEmpty = !+this.props.cartItems.length;

    const resultsContainerClassName = cx(styles.searchResultsContainer, {
      [styles.searchResultsContainerNarrow]: !isCartEmpty,
    });

    return (
      <div className="container">
      <div className={styles.searchPageContainer}>
        <ToCartPopup
          {...this.props}
          isOpen={this.props.isOpen}
          closeToCartPopup={this.props.toCartActions.closeToCartPopup}
          changeToCartItemQuantity={this.props.toCartActions.changeToCartItemQuantity}
          changeToCartComment={this.props.toCartActions.changeToCartComment}
          addItemToCart={this.props.toCartActions.addItemToCart}
           />
        <SearchPageHeader
          foundDetail={this.props.foundDetail}
          isCartEmpty={isCartEmpty}
          searchQuery={this.props.searchQuery}/>

          <div className={styles.resultsBlock}>
            <div className={resultsContainerClassName}>
              <SearchInfo
                showMap={this.showMap}
                openToCartPopup={this.props.openToCartPopup}
                foundDetail={this.props.foundDetail}
                foundDetailOffers={this.props.foundDetailOffers}
                inStock={this.props.inStock}
                priceMinValue={this.props.priceMinValue}
                priceMaxValue={this.props.priceMaxValue}
                filterInStock={this.props.filterInStock}
                filterPriceMinValue={this.props.filterPriceMinValue}
                filterPriceMaxValue={this.props.filterPriceMaxValue}
                isAskSupplier={this.props.isAskSupplier}
                supplierFilterValues={this.props.supplierFilterValues}
                filterSupplier={this.props.filterSupplier}
                bestOfferValue={this.props.bestOfferValue}
                filterBestOffers={this.props.filterBestOffers}
                />
              {false ?  // isCartEmpty
                <SearchMap
                  cartItemsLength={this.props.cartItems.length} />
                : null
              }
            </div>
          </div>

        <Media query="(max-width: 1024px)">
          <div>
            {/*<SearchMap onMapClick={this.onMapClick} />
            <SearchInfoMobile openToCartPopup={this.props.toCartActions.openToCartPopup} />*/}

          </div>
        </Media>
      </div>
      </div>
    );
  }
}

SearchResults.contextTypes = {
  location: React.PropTypes.object
};

SearchResults.routeTitle = "Результаты поиска";

const mapStateToProps = (state) => ({
  ...state.searchReducer,
  cartItems: state.cartReducer.cartItems,
  toCartQuantity: state.toCartPopupReducer.toCartQuantity,
  toCartPopupComment: state.toCartPopupReducer.toCartPopupComment,
  changeToCartItemQuantity: state.toCartPopupReducer.changeToCartItemQuantity,
  isOpen: state.toCartPopupReducer.isOpen,
});

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators(actions, dispatch),
    toCartActions: bindActionCreators(toCartActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchResults);



/** WEBPACK FOOTER **
 ** ./src/components/SearchResults/SearchResults.jsx
 **/